import React from 'react';
import './AuthBackground.scss';

const currentYear = new Date().getFullYear();

const AuthBackground = (props) => (
	<div className='AuthBackground'>
		<div className='logo'>
			<img src='./assets/images/svg/logo_white.svg' />
		</div>
		<div className='content'>
			{props.children}
		</div>
		<div  className='auth-footer'>
			<p className='copyright'>&copy; {currentYear} <span className="medium">LeanWisdom</span></p>
			
			<div className="brand-logo">	
			<span className="logo-text">Maintained by</span>				
			<a className="plexcel-logo" href="https://www.plexcel.com/" target="_blank">
				<img   src='./assets/images/png/plexcellogo.png' />
			</a>
				{/* <div className="goodux-name">" UX . UI by GoodUX "</div> */}
			</div>
		</div>
	</div>
);

export default AuthBackground;



// WEBPACK FOOTER //
// ./components/Auth/AuthBackground/AuthBackground.js